/**
 * The state this code just reached is forbidden by design, so there is nothing sensible to do with
 * it. Use it instead of a fake branch, a silent return, or a `!` - those all read as real behaviour.
 *
 * Two shapes:
 *   const version = documentContext.version ?? impossibleState('edit mode without a draft');
 *   default: { const unsupported: never = kind; impossibleState(`kind ${unsupported}`); }
 */
export const impossibleState = (message: string): never => {
  throw new Error(`Impossible state: ${message}`);
};
